<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h1>Showcase</h1>
            <!-- <p>This is Our Portfolio</p> -->
        </div>
    </div>
</div>

<!-- <section class="services-area bg-right-shape ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-content it-service-content">
                <div class="content left-content">
                    <div class="icon">
                        <img src="assets/img/icon1.png" alt="">
                    </div>
                    <h2>Web Design and Development</h2>
                    <p>We emphasize in developing an engaging website that can withstand the competitiveness within the industry while maintain a close relationship with the customer throughout the designing  process.this co-operative approach ensures that the customer is fully in the loop from beginning of website design till the end product,and that the final product is the one that truly takes your business  image to a whole new level.</p>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i>  Responsive Design
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> UI / UX Design
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Mobile App Development
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Laravel Web Development
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> React Web Development
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Angular Web Development
                            </div>
                        </div>
                    </div>
                    <a routerLink="/about" class="default-btn"><i class="bx bxs-spreadsheet"></i> Learn More<span></span></a>
                </div>
            </div>
            <div class="services-image wow fadeInRight" data-wow-delay=".3s">
                <div class="image">
                    <img src="assets/img/services-image/service1.png" alt="">
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- <section class="services-area bg-left-color bg-left-shape bg-f4f6fc ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-image wow fadeInLeft" data-wow-delay=".3s">
                <div class="image">
                    <img src="assets/img/services-image/service2.png" alt="">
                </div>
            </div>
            <div class="services-content it-service-content">
                <div class="content">
                    <div class="icon">
                        <img src="assets/img/icon1.png" alt="">
                    </div>
                    <h2>Mobile Application Development</h2>
                    <p>We provide your desired user friendly mobile application loaded with advanced features within the agreed period of time, providing the best customer care services throughout the process. We bring your companies dream mobile application to reality</p>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i>  Platforms and aggregate  networks
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Android app development
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Ios app development
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> Hybrid app development
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box">
                                <i class='bx bxs-badge-check'></i> AR/VR App development
                            </div>
                        </div>
                    </div>
                    <a routerLink="/about" class="default-btn"><i class="bx bxs-spreadsheet"></i>Learn More<span></span></a>
                </div>
            </div>
        </div>
    </div>
</section> -->


@for (group of groups; track group.title; let odd = $odd) {
<section class="showcase-group pt-100 pb-70" [class.bg-f4f5fe]="!odd">
    <div class="container">
        <div class="section-title">
            <h2>{{ group.title }}</h2>
            <p>{{ group.intro }}</p>
        </div>
        <div class="row">
            @for (project of group.projects; track project.name) {
            <div class="col-lg-4 col-sm-6">
                <div class="single-blog-post">
                    <div class="post-image">
                        @if (project.url) {
                        <a [href]="project.url" target="_blank" rel="noopener noreferrer" tabindex="-1" aria-hidden="true">
                            <img loading="lazy" decoding="async" [src]="project.image" width="860" height="700"
                                [alt]="'Homepage of the ' + project.name + ' website'">
                        </a>
                        } @else {
                        <img loading="lazy" decoding="async" src="assets/img/blog-image/comigSoon.jpg" alt="">
                        }
                    </div>
                    <div class="post-content">
                        <h3>
                            @if (project.url) {
                            <a [href]="project.url" target="_blank" rel="noopener noreferrer">{{ project.name }}
                                <i class="bx bx-link-external" aria-hidden="true"></i><span class="visually-hidden"> (opens in a new tab)</span></a>
                            } @else {
                            {{ project.name }}
                            }
                        </h3>
                        @if (!project.url) {
                        <span class="coming-soon">Coming soon</span>
                        }
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</section>
}


<section class="free-trial-area ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="free-trial-content">
            <h2>Like what you see? Let’s build yours next.</h2>
            <!-- <p>Qualify your leads & recognize the value of word your customer will love you</p> -->
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot" aria-hidden="true"></i>Get in Touch<span></span></a>
        </div>
    </div>
    <!-- <div class="shape10"><img src="assets/img/shape/shape10.png" alt=""></div>
    <div class="shape11"><img src="assets/img/shape/shape7.png" alt=""></div>
    <div class="shape12"><img src="assets/img/shape/shape11.png" alt=""></div>
    <div class="shape13"><img src="assets/img/shape/shape12.png" alt=""></div> -->
</section>